<ng-wizard #wizard [attr.id]="field.id" [config]="{ selected: currentStepIndex }" (stepChanged)="onStepChanged($event)">
  <ng-wizard-step
    #wizardSteps
    *ngFor="let field of field?.fieldGroup; let index = index; let last = last"
    [attr.id]="field.id"
    [canExit]="!isStepErrored(index)"
    [class.error]="isStepErrored(index)"
    [class.visited]="highestVisitedStep > index"
    [state]="getState(field)"
    [title]="getStepTitle(field, index)"
    class="wizard-step"
  >
    <div *ngIf="!!field.props.stepPreambleTemplate" class="step-preamble">
      <ng-container [ngTemplateOutlet]="field.props.stepPreambleTemplate"></ng-container>
    </div>

    <formly-field [field]="field"></formly-field>

    <div *ngIf="!!field.props.stepActionsTemplate" class="step-actions text-end">
      <ng-container [ngTemplateOutlet]="field.props.stepActionsTemplate"></ng-container>
    </div>

    <div [class.fixed]="props.fixed" class="form-actions">
      <div class="form-actions-container">
        <button
          [class.loading]="loadingService.loading$ | async"
          [disabled]="isFirstStep(index)"
          (click)="goToPreviousStep($event, index)"
          class="btn btn-outline-secondary"
        >
          {{ "Previous" | translate }}
        </button>

        <button
          [class.loading]="loadingService.loading$ | async"
          [disabled]="isLastStep(index)"
          (click)="goToNextStep($event, index)"
          class="btn btn-outline-primary"
        >
          {{ "Next" | translate }}
        </button>

        <ng-container *ngIf="props.buttonsTemplate" [ngTemplateOutlet]="props.buttonsTemplate"></ng-container>
      </div>
    </div>
  </ng-wizard-step>
</ng-wizard>
